import styled from "styled-components";
import { theme } from "../../styles/theme";

export const Container = styled.div`
    width: 100%;
    height: auto;
`

export const Wrapper = styled.div`
    width: 100%;
    height: auto;

    gap: 16px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
`

export const Card = styled.div`
    width: 100%;
    height: auto;
    padding: 16px;
    max-width: 247.5px;

    gap: 16px;
    display: flex;
    align-items: center;
    flex-direction: column;

    cursor: pointer;
    border-radius: 16px;
    background-color: ${theme.colors.gray.Cinza_12};

    @media (max-width: 479px) {
      max-width: 100%;
    }
`

export const CardHeader = styled.div`
    width: 100%;
    height: auto;

    display: flex;
    align-items: start;
    flex-direction: column;

    overflow-x: auto;

    >span {
        white-space: nowrap;
    }

    &::-webkit-scrollbar {
      width: 3px;
      height: 3px;
    }

    &::-webkit-scrollbar-track {
      background: transparent;
    }

    &::-webkit-scrollbar-thumb {
      background-color: rgba(0, 0, 0, 0.2);
      border-radius: 1rem;
    }
`

export const CardGraphic = styled.div`
    width: 100%;
    height: 80px;

    display: flex;
    align-items: start;
    flex-direction: column;
`

export const ChartContainer = styled.div`
    width: 100%;
    height: 100%;
    
    flex-grow: 1;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const Divider = styled.div`
    width: 100%;
    height: 2px;

    background-color: ${theme.colors.gray.Cinza_10};
`

export const CardFooterInfo = styled.div`
    width: 100%;
    height: auto;

    display: flex;
    justify-content: space-between;

    >p,span{
        letter-spacing: 0.05rem;
    }
`